import { UnknownAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import type { AppState } from '~/reducers';
import { NativeCommand, NativeCommandEnum } from '../models/commands';
import {
  GUARDED_COMMANDS,
  IN_FLIGHT_TTL_MS,
  getNativeCommandKey,
} from '../utils/native-command-key';
import {
  dispatchNativeCommand,
  markNativeCommandInFlight,
  pruneExpiredInFlightCommands,
} from './reducer';

/** Dispatch a native command, dropping duplicates of guarded commands while in-flight. */
export const dispatchNativeCommandGuarded =
  (
    command: NativeCommand<NativeCommandEnum>
  ): ThunkAction<void, AppState, unknown, UnknownAction> =>
  (dispatch, getState) => {
    if (!GUARDED_COMMANDS.has(command.name)) {
      dispatch(dispatchNativeCommand(command));
      return;
    }

    const now = Date.now();
    dispatch(pruneExpiredInFlightCommands({ now }));

    const key = getNativeCommandKey(command);
    const inFlight = getState().native.inFlightNativeCommands?.[key];
    if (inFlight !== undefined && inFlight > now) {
      return;
    }

    dispatch(markNativeCommandInFlight({ key, expiresAt: now + IN_FLIGHT_TTL_MS }));
    dispatch(dispatchNativeCommand(command));
  };
